import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function UmamiPageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (window.umami) {
      window.umami.track((props) => ({
        ...props,
        url: location.pathname + location.search,
      }));
    }
  }, [location.pathname, location.search]);

  return null;
}
